export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'movie', name: '热门影视', icon: 'ri-movie-2-line' },
  { slug: 'short', name: '短视频', icon: 'ri-vidicon-line' },
  { slug: 'variety', name: '综艺娱乐', icon: 'ri-emotion-laugh-line' },
  { slug: 'anime', name: '动漫动画', icon: 'ri-ghost-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'music', name: '音乐MV', icon: 'ri-music-2-line' },
  { slug: 'sports', name: '体育赛事', icon: 'ri-basketball-line' },
];